/* @flow */
import React from 'react';
import Button from 'components/Button.jsx';
import Glyph from 'components/Glyph.jsx';
import ModalTrigger from 'components/ModalTrigger.jsx';
import ActivityCreateDialogContainer from 'payments/containers/ActivityCreateDialogContainer.jsx';
import EventTrackingConstants from 'payments/constants/EventTrackingConstants';

import './styles/ActivitiesClassViewHeaderActions.scss';

const UI_CONTEXT = 'activities_page';

type Props = {
  canCreateActivity: boolean,
  canGoToTransactionSettings: boolean,
}

class ActivitiesClassViewHeaderActions extends React.Component {
  props: Props;

  render() {
    const shouldRender = (
      this.props.canCreateActivity ||
      this.props.canGoToTransactionSettings
    );

    if (!shouldRender) {
      return null;
    }

    return (
      <div className="ActivitiesClassViewHeaderActions">
        <div className="ActivitiesClassViewHeaderActions-row">
          {this.props.canGoToTransactionSettings &&
            <Button to="/settings/transactions" level="secondary" size="xsmall">
              <Glyph name="gear" size="small" />
            </Button>
          }

          {this.props.canCreateActivity &&
            <ModalTrigger modal={<ActivityCreateDialogContainer />}>
              <Button
                size="xsmall"
                eventScreenName={EventTrackingConstants.YOUR_CAMPAIGN_PAYMENTS}
                eventElementName="create_activity"
                eventContextName={UI_CONTEXT}>
                Create an activity
              </Button>
            </ModalTrigger>
          }
        </div>
      </div>
    );
  }
}

export default ActivitiesClassViewHeaderActions;



// WEBPACK FOOTER //
// ./src/payments/components/ActivitiesClassViewHeaderActions.jsx